import script from "./RangePickerComp.vue?vue&type=script&setup=true&lang=js"
export * from "./RangePickerComp.vue?vue&type=script&setup=true&lang=js"

import "./RangePickerComp.vue?vue&type=style&index=0&id=f2bf7986&lang=css"

const __exports__ = script;

export default __exports__